import { jwtDecode } from "jwt-decode";

export function hasPermission(permissionKeys = []) {
  const token = localStorage.getItem("accessToken");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const permMap = decoded.permissions || {};

    // ไม่มี key ใดเลย = ผ่านทั้งหมด
    if (permissionKeys.length === 0) return true;

    // ถ้ามี key ใดที่เป็น true → ผ่าน
    return permissionKeys.some((k) => permMap?.[k] === true);
  } catch (e) {
    console.error("Token decode error:", e);
    return false;
  }
}
